<template>
  <div class="my-main-content-web">
    <div style="margin-top:5vh;">
      <h3 class="text3D">
        <span @click="$routerTo('/Admin')" style="border-bottom: 1px solid;cursor: pointer;">後台設定</span>
        <span> / </span>
        <span>區域管理 </span>

        <el-button class="no-print" type="success" @click="showAddDialog()" style="margin-top: 10px; margin-bottom: 10px">新增</el-button>
      </h3>

      <el-row type="flex" justify="center" style="margin-top: 10px">
        <el-col :xs="24" :sm="18" :md="18">
          <el-row>
            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>樓層 </el-col>

            <el-col :xs="18" :sm="9">
              <el-select @change="chageFloor" v-model="selected_floor" placeholder="樓層">
                <el-option v-for="item in options_floor" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-col>

            <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>區域 </el-col>

            <el-col :xs="18" :sm="9">
              <el-select @change="chageArea" v-model="selected_area" placeholder="選擇區域">
                <el-option v-for="(item, index) in options_area" :key="index" :label="item['area_zh-TW']" :value="item.recno"></el-option>
              </el-select>
            </el-col>
          </el-row>

          <hr />

          <div v-if="selected_area">
            <h3 class="text3D">
              <span>修改 </span>
            </h3>

            <el-row style="margin-top: 10px">
              <el-row type="flex" justify="center" align="middle">
                <el-col :xs="18" :sm="9">
                  <el-row>
                    <el-radio v-model="post.active" label="1">啟用</el-radio>
                    <el-radio v-model="post.active" label="0">不啟用</el-radio>
                  </el-row>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" style="margin-top: 10px">
                <el-col :xs="24" :sm="18" :md="18">
                  <el-row type="flex" justify="center" align="middle">
                    <el-col :xs="6" :sm="3"> <span style="color:red">*</span>新名稱 </el-col>

                    <el-col :xs="18" :sm="9">
                      <el-input v-model.trim="post['area_zh-TW']" placeholder="名稱"></el-input>
                    </el-col>
                  </el-row>

                  <hr />

                  <el-button @click="translate()" type="warning" size="sm">自動翻譯</el-button>

                  <el-row>
                    <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>簡體 </el-col>

                    <el-col :xs="18" :sm="9">
                      <el-input v-model.trim="post['area_zh-CN']" placeholder="簡體"></el-input>
                    </el-col>

                    <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>英語 </el-col>

                    <el-col :xs="18" :sm="9">
                      <el-input v-model.trim="post['area_en']" placeholder="英語"></el-input>
                    </el-col>

                    <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>韓語 </el-col>

                    <el-col :xs="18" :sm="9">
                      <el-input v-model.trim="post['area_ko']" placeholder="韓語"></el-input>
                    </el-col>

                    <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>日語 </el-col>

                    <el-col :xs="18" :sm="9">
                      <el-input v-model.trim="post['area_ja']" placeholder="日語"></el-input>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-row>

            <el-button class="no-print" type="warning" @click="putArea()" style="margin-top: 10px; margin-bottom: 10px">修改</el-button>
          </div>
        </el-col>
      </el-row>

      <!-- 建立 -->
      <el-dialog title="新增" :visible.sync="dialogVisible_add" width="80%">
        <el-row style="margin-top: 10px">
          <el-row type="flex" justify="center" align="middle">
            <el-col :xs="18" :sm="9">
              <el-row>
                <el-radio v-model="post.active" label="1">啟用</el-radio>
                <el-radio v-model="post.active" label="0">不啟用</el-radio>
              </el-row>
            </el-col>
          </el-row>

          <el-row type="flex" justify="center" style="margin-top: 10px">
            <el-col :xs="24" :sm="18" :md="18">
              <el-row>
                <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>樓層 </el-col>

                <el-col :xs="18" :sm="9">
                  <el-select @change="chageFloor" v-model="selected_floor" placeholder="樓層">
                    <el-option v-for="item in options_floor" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                </el-col>

                <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>區域 </el-col>

                <el-col :xs="18" :sm="9">
                  <el-input v-model.trim="post['area_zh-TW']" placeholder="繁體"></el-input>
                </el-col>
              </el-row>

              <hr />

              <el-button @click="translate()" type="warning" size="sm">自動翻譯</el-button>

              <el-row>
                <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>簡體 </el-col>

                <el-col :xs="18" :sm="9">
                  <el-input v-model.trim="post['area_zh-CN']" placeholder="簡體"></el-input>
                </el-col>

                <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>英語 </el-col>

                <el-col :xs="18" :sm="9">
                  <el-input v-model.trim="post['area_en']" placeholder="英語"></el-input>
                </el-col>

                <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>韓語 </el-col>

                <el-col :xs="18" :sm="9">
                  <el-input v-model.trim="post['area_ko']" placeholder="韓語"></el-input>
                </el-col>

                <el-col :xs="6" :sm="3" style="margin-top: 8px;"> <span style="color:red">*</span>日語 </el-col>

                <el-col :xs="18" :sm="9">
                  <el-input v-model.trim="post['area_ja']" placeholder="日語"></el-input>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_add = false">取 消</el-button>
          <el-button type="primary" @click="postArea()">確 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import cloneDeep from "lodash.clonedeep";
import { tify, sify } from "chinese-conv";

export default {
  data() {
    return {
      dialogVisible_add: false,
      options_floor: ["1", "2", "3"],
      options_area: [],
      selected_floor: "",
      selected_area: "",
      post: {
        "area_zh-TW": "",
        "area_zh-CN": "",
        area_en: "",
        area_ko: "",
        area_ja: "",
        floor: "",
        recno: "",
        active: ""
      }
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.$store.commit("set_page", location.hash);
  },
  methods: {
    init() {
      this.selected_floor = "";
      this.selected_area = "";
      this.post = {
        "area_zh-TW": "",
        "area_zh-CN": "",
        area_en: "",
        area_ko: "",
        area_ja: "",
        floor: "",
        recno: "",
        active: "1"
      };
    },
    chageFloor(val) {
      this.selected_area = "";

      let areas = JSON.parse(localStorage.getItem("areas"));

      if (val == "1") {
        this.options_area = areas.filter(el => {
          return el.floor == 1;
        });
      } else if (val == "2") {
        this.options_area = areas.filter(el => {
          return el.floor == 2;
        });
      } else if (val == "3") {
        this.options_area = areas.filter(el => {
          return el.floor == 3;
        });
      }
    },
    showAddDialog() {
      this.dialogVisible_add = true;
      this.init();
    },
    chageArea(val) {
      this.post["area_zh-TW"] = "";
      this.post["area_zh-CN"] = "";
      this.post["area_en"] = "";
      this.post["area_ko"] = "";
      this.post["area_ja"] = "";

      this.options_area.forEach(el => {
        if (el.recno == val) {
          this.post = cloneDeep(el);
        }
      });
    },
    async translate() {
      if (!this.post["area_zh-TW"]) {
        this.$message.warning("必填欄位，不可空白！");
        return false;
      }

      this.$store.commit("setLoadingMask", true);

      this.post["area_zh-CN"] = sify(this.post["area_zh-TW"]);

      let api_key = "AIzaSyDvidOES_35o1dylx-03Y8_9XGvNviN9oY";
      let text_en = "&q=" + this.post["area_zh-TW"];
      function getTranslateEn() {
        return axios.get("https://translation.googleapis.com/language/translate/v2?key=" + api_key + text_en + "&target=en&source=zh&format=text");
      }
      let text_ko = "&q=" + this.post["area_zh-TW"];
      function getTranslateKo() {
        return axios.get("https://translation.googleapis.com/language/translate/v2?key=" + api_key + text_ko + "&target=ko&source=zh&format=text");
      }
      let text_ja = "&q=" + this.post["area_zh-TW"];
      function getTranslateJa() {
        return axios.get("https://translation.googleapis.com/language/translate/v2?key=" + api_key + text_ja + "&target=ja&source=zh&format=text");
      }

      await Promise.all([getTranslateEn(), getTranslateKo(), getTranslateJa()]).then(results => {
        console.log(results);
        this.post["area_en"] = results[0].data.data.translations[0].translatedText;
        this.post["area_ko"] = results[1].data.data.translations[0].translatedText;
        this.post["area_ja"] = results[2].data.data.translations[0].translatedText;
      })
      .catch(e => {
        console.log(e)
        this.$message.warning("翻譯時似乎出了點問題，請聯繫開發人員！");
      })
      .finally(()=>{
        this.$store.commit("setLoadingMask", false);
      });
    },
    async putArea() {
      this.post.floor = this.selected_floor;

      if (!this.post["area_zh-TW"] || !this.post["area_zh-CN"] || !this.post["area_en"] || !this.post["area_ko"] || !this.post["area_ja"] || !this.post.floor) {
        this.$message.warning("必填欄位不可空白");
        return false;
      }

      this.$store.commit("setLoadingMask", true);

      await axios
        .put("/api/area", this.post)
        .then(response => {
          console.log(response);
          this.$message.success("修改成功");
          this.selected_floor = "";
        })
        .catch(error => {
          console.log(error.message);
        });

      await this.$getArea();

      this.init();

      this.$store.commit("setLoadingMask", false);
    },
    async postArea() {
      // this.post["area_zh-TW"] = this.selected_area;
      this.post.floor = this.selected_floor;
      delete this.post.recno;

      if (!this.post["area_zh-TW"] || !this.post["area_zh-CN"] || !this.post["area_en"] || !this.post["area_ko"] || !this.post["area_ja"] || !this.post.floor) {
        this.$message.warning("必填欄位不可空白");
        return false;
      }
      this.$store.commit("setLoadingMask", true);

      await axios
        .post("api/area", this.post)
        .then(response => {
          console.log(response);
          this.$message.success("新增成功");
          this.dialogVisible_add = false;
          this.selected_floor = "";
        })
        .catch(error => {
          console.log(error.message);
        });

      await this.$getArea();

      this.init();

      this.$store.commit("setLoadingMask", false);
    }
  }
};
</script>

<style scoped></style>
